import { Modal } from '@sendible/design-system/src';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { FlexContent, Container } from '../styles/index.styles';
import { LoadingState } from '../LoadingState';
import { useComposeBoxContext } from '../../../composeBoxContext';

export const CanvaModal = () => {
  const { setIsCanvaModalOpen } = useComposeBoxContext();
  const { t } = useTranslation('common_terms');

  // Mock states. Replace this with model data/states
  const [isLoading, setIsLoading] = useState<boolean>(true);
  // End of mock state

  useEffect(() => {
    setTimeout(() => setIsLoading(false), 2000);
  }, []);

  return (
    <Modal
      close={() => setIsCanvaModalOpen(false)}
      headingIcon="canva"
      headingTitle={t('canva') as string}
      variation="large"
    >
      <Container>
        <FlexContent>{isLoading ? <LoadingState useSpinner /> : <>Canva content should be placed here</>}</FlexContent>
      </Container>
    </Modal>
  );
};
